<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <AreaEdit />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import AreaEdit from "./components/AreaEdit";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    AreaEdit,
    // ProjectsTable,
  },
};
</script>
